<template>
  <div v-if="detailsData.data">
    <div
      v-if="
        (detailsData.data && detailsData.data.userType == 0) ||
        detailsData.data.userType == 2
      "
      class="Publisher"
    >
      <div class="title">发布者</div>
      <div @click="goBkOrBj" class="logo">
        <img
          v-if="autherInfo.headImg"
          v-lazy="`${$global.imgUrl}${autherInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/qikan.png" alt="" />
        <span>{{ autherInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div v-if="autherInfo.foundedDate" class="listItem">
          <div class="time">{{ autherInfo.foundedDate }}</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ timeData.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div class="listItem">
          <div class="time">{{ timeData.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div v-if="timeData.letterCount" class="listItem">
          <div class="time">{{ timeData.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div
      v-if="detailsData.data && detailsData.data.userType == 1"
      class="Publisher"
    >
      <div class="title">期刊</div>
      <div @click="goBk" class="logo">
        <!-- periodicalLogo -->
        <img
          v-if="periodicalInfo.headImg"
          v-lazy="`${$global.imgUrl}${periodicalInfo.headImg}`"
          alt=""
        />
        <img v-else src="@/assets/img/details/qikan.png" alt="" />
        <span>{{ periodicalInfo.name }}</span>
      </div>
      <div class="list">
        <!-- <div class="listItem">
          <div class="time">{{ periodicalInfo.foundedDate }}</div>
          <div class="text">创刊时间</div>
        </div> -->
        <div class="listItem">
          <div class="time">{{ periodiID.thesisCount }}</div>
          <div class="text">文献数</div>
        </div>
        <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ periodiID.informationCount }}</div>
          <div class="text">资讯数</div>
        </div>
        <!-- <div
          v-if="detailsData.data && detailsData.data.userType === 1"
          class="listItem"
        >
          <div class="time">{{ periodiID.letterCount }}</div>
          <div class="text">征稿函</div>
        </div> -->
      </div>
    </div>
    <div class="wenxian">
      <div class="title">相似报告</div>
      <ul class="ulList">
        <li
          @click="detailsClick(item)"
          :class="i + 1 === wenxian.length ? '' : 'msg'"
          v-for="(item, i) in wenxian"
          :key="item.articleId"
          style="cursor: pointer"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "right",
  props: [
    "wenxian",
    "detailsData",
    "autherInfo",
    "periodicalId",
    "periodicalInfo",
    "timeData",
  ],
  data() {
    return {};
  },
  computed: {
    ...mapState(["hasLogin"]),
  },
  methods: {
    detailsClick(e) {
      let routerUrl = "";
      if (e.articleType === 0 && e.type === 0) {
        routerUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 0 && e.type === 3) {
        routerUrl = this.$router.resolve({
          path: "/thesisDetail",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 6) {
        routerUrl = this.$router.resolve({
          path: "/dataDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      } else if (e.articleType === 5) {
        routerUrl = this.$router.resolve({
          path: "/msgDetails",
          query: {
            type: e.articleType,
            id: e.articleId,
          },
        });
      }

      window.open(routerUrl.href, "_blank");
    },
    goBkOrBj() {
      // if (!this.hasLogin) {
      //   return;
      // }
      if (this.detailsData.data.userType === 2) {
        this.$router.push(
          `/jghdetail?title=机构号&id=${this.detailsData.data.companyId}`
        );
      } else {
        this.$router.push(
          `/${
            this.detailsData.data.userType === 1 ? "bkzxdetail" : "bjzxdetail"
          }?title=${
            this.detailsData.data.userType === 1 ? "百科在线" : "百家在线"
          }&id=${
            this.detailsData.data.userType === 1
              ? this.detailsData.data.companyId
              : this.detailsData.data.createUser
          }`
        );
      }
    },
    goBk() {
      // console.log(this.periodicalInfo.id);
      this.$router.push(
        `/bkzxdetail?title=百科在线&id=${this.periodicalInfo.id}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.wenxian {
  width: 270px;
  //height: 250px;
  //padding-left: 25px;
  padding-top: 20px;
  padding-bottom: 40px;
  background: #ffffff;
  margin-left: 10px;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
  //.xian{
  //  width: 270px;
  //  height: 1px;
  //  top: 60px;
  //  border: 1px solid #E5E5E5;
  //  background: pink;
  //  right: 0px;
  //}
  .ulList {
    padding-left: 25px;
    padding-right: 25px;

    li {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }

    .msg {
      //width: 240px;
      //height: 37px;
      margin-top: 15px;
      padding-bottom: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      //line-height: 24px;
      border-bottom: 1px dashed #e8e8e8;
      //border-style: dashed;
    }
  }

  .title {
    font-size: 18px;

    font-weight: bold;
    height: 20px;
    line-height: 20px;
    color: #333333;
    width: 270px;
    padding-left: 25px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e5e5e5;
    //border-bottom: 1px solid #000;
  }
}

.Publisher {
  width: 270px;
  height: 250px;
  padding-left: 25px;
  padding-top: 20px;
  background: #ffffff;
  box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.07);
  margin-left: 10px;
  margin-bottom: 10px;

  .title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    //line-height: 24px;
  }

  .logo {
    display: flex;
    width: 220px;
    flex-wrap: wrap;
    //background: pink;
    justify-content: center;
    margin-top: 10px;

    img {
      width: 84px;
      height: 84px;
      border-radius: 50%;
      cursor: pointer;
    }

    span {
      cursor: pointer;
      margin-top: 15px;
      text-align: center;
      width: 245px;
      // height: 18px;
      font-size: 18px;
      //font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      line-height: 24px;
      white-space: nowrap; //不换行
      overflow: hidden; //超出隐藏
      text-overflow: ellipsis; //变成...
    }
  }

  .list {
    width: 220px;
    display: flex;
    margin-top: 24px;
    justify-content: space-around;

    .listItem {
      width: 50px;
      height: 50px;
      text-align: center;
      align-items: center;
      margin-top: -5px;

      .text {
        text-align: center;
        //width: 48px;
        //height: 11px;
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 24px;
      }

      .time {
        //background: pink;
        //width: 44px;
        //height: 17px;
        font-size: 20px;
        font-family: Dancing Script;
        font-weight: bold;
        color: #ff7d14;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
</style>
